// @generated by protoc-gen-es v2.2.2 with parameter "target=ts"
// @generated from file sitedeviceselections.proto (package docs, syntax proto3)

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file sitedeviceselections.proto.
 */
export const file_sitedeviceselections: GenFile = /*@__PURE__*/ fileDesc(
    "ChpzaXRlZGV2aWNlc2VsZWN0aW9ucy5wcm90bxIEZG9jcyIaChhTZWxlY3RlZERldmljZVByb3BlcnRpZXMiUgoKU2l0ZURldmljZRIQCghkZXZpY2VJZBgBIAEoCRIyCgpwcm9wZXJ0aWVzGAIgASgLMh4uZG9jcy5TZWxlY3RlZERldmljZVByb3BlcnRpZXMiiwEKE1NpdGVEZXZpY2VTZWxlY3Rpb24SDgoGc2l0ZUlkGAEgASgJEiUKHWRldmljZVNlbGVjdGlvbklzRG9uZUJ5UGFnaW5nGAIgASgIEikKD3NlbGVjdGVkRGV2aWNlcxgDIAMoCzIQLmRvY3MuU2l0ZURldmljZRISCgpwYWdlTnVtYmVyGAQgASgFIkMKF1NpdGVEZXZpY2VTZWxlY3Rpb25saXN0EigKBXZhbHVlGAEgAygLMhkuZG9jcy5TaXRlRGV2aWNlU2VsZWN0aW9uYgZwcm90bzM",
);

/**
 * @generated from message docs.SelectedDeviceProperties
 */
export type SelectedDeviceProperties =
    Message<"docs.SelectedDeviceProperties"> & {};

/**
 * Describes the message docs.SelectedDeviceProperties.
 * Use `create(SelectedDevicePropertiesSchema)` to create a new message.
 */
export const SelectedDevicePropertiesSchema: GenMessage<SelectedDeviceProperties> =
    /*@__PURE__*/ messageDesc(file_sitedeviceselections, 0);

/**
 * @generated from message docs.SiteDevice
 */
export type SiteDevice = Message<"docs.SiteDevice"> & {
    /**
     * @generated from field: string deviceId = 1;
     */
    deviceId: string;

    /**
     * @generated from field: docs.SelectedDeviceProperties properties = 2;
     */
    properties?: SelectedDeviceProperties;
};

/**
 * Describes the message docs.SiteDevice.
 * Use `create(SiteDeviceSchema)` to create a new message.
 */
export const SiteDeviceSchema: GenMessage<SiteDevice> =
    /*@__PURE__*/ messageDesc(file_sitedeviceselections, 1);

/**
 * @generated from message docs.SiteDeviceSelection
 */
export type SiteDeviceSelection = Message<"docs.SiteDeviceSelection"> & {
    /**
     * @generated from field: string siteId = 1;
     */
    siteId: string;

    /**
     * @generated from field: bool deviceSelectionIsDoneByPaging = 2;
     */
    deviceSelectionIsDoneByPaging: boolean;

    /**
     * @generated from field: repeated docs.SiteDevice selectedDevices = 3;
     */
    selectedDevices: SiteDevice[];

    /**
     * @generated from field: int32 pageNumber = 4;
     */
    pageNumber: number;
};

/**
 * Describes the message docs.SiteDeviceSelection.
 * Use `create(SiteDeviceSelectionSchema)` to create a new message.
 */
export const SiteDeviceSelectionSchema: GenMessage<SiteDeviceSelection> =
    /*@__PURE__*/ messageDesc(file_sitedeviceselections, 2);

/**
 * @generated from message docs.SiteDeviceSelectionlist
 */
export type SiteDeviceSelectionlist =
    Message<"docs.SiteDeviceSelectionlist"> & {
        /**
         * @generated from field: repeated docs.SiteDeviceSelection value = 1;
         */
        value: SiteDeviceSelection[];
    };

/**
 * Describes the message docs.SiteDeviceSelectionlist.
 * Use `create(SiteDeviceSelectionlistSchema)` to create a new message.
 */
export const SiteDeviceSelectionlistSchema: GenMessage<SiteDeviceSelectionlist> =
    /*@__PURE__*/ messageDesc(file_sitedeviceselections, 3);
